jQuery(function ($) {
    if ( $('.lesson__slide1').length ) {
        $('.lesson__slide1').on('init', function (event, slide) {
            $('.lesson__slide1').removeClass('m-hidden');
        } );
        $('.lesson__slide1').slick({
            infinite: false,
            centerMode: true,
            centerPadding: '16px',
            asNavFor: '.lesson__slide2',
        });
    }
    if ( $('.lesson__slide2').length ) {
        $('.lesson__slide2').on('beforeChange', function (event, slide) {
            $('.lesson__slide2 .lesson__progress-bar').css('visibility','hidden');
            $('.lesson__slide2 .lesson__progress-bar').css('width','2px');
        } );
        $('.lesson__slide2').on('afterChange', function (event, slide) {
            $('.lesson__slide2 .slick-current .lesson__progress-bar').css('visibility','visible');
            if ( window.util.is_visible( $('.lesson__slide2 .slick-current .lesson__progress-bar') ) ){
                let width_var = $('.lesson__slide2 .slick-current .lesson__progress-bar').attr('data-width');
                if ( width_var > 2 ) {
                    $('.lesson__slide2 .slick-current .lesson__progress-bar').css('width',width_var + '%');
                }
            }
        } );
        $('.lesson__slide2').on('init', function (event, slide) {
            $('.lesson__slide2').removeClass('m-hidden');
        } );
        $('.lesson__slide2').slick({
            infinite: false,
            arrows: false,
            asNavFor: '.lesson__slide1',
            fade: true,
            adaptiveHeight: true,
        });
        $('.lesson__slide2 .slick-current .lesson__progress-bar').on('inview', function(){
            let width_var = $('.lesson__slide2 .slick-current .lesson__progress-bar').attr('data-width');
            if ( width_var > 2 ) {
                $('.lesson__slide2 .slick-current .lesson__progress-bar').css('width',width_var + '%');
            }
        });
    }

});
